import { useQuery } from '@tanstack/react-query';
import { formatPkr } from '@raahi/shared';
import { Shell } from '../layout/Shell.js';
import { DataTable, type Column } from '../components/DataTable.js';
import { listRiders, type RiderRow } from '../api/admin.js';

export function RidersPage() {
  const riders = useQuery({ queryKey: ['admin-riders'], queryFn: listRiders });

  const columns: Column<RiderRow>[] = [
    { key: 'name', header: 'Name', cell: (r) => <span className="font-medium">{r.name}</span> },
    { key: 'email', header: 'Email', cell: (r) => <span className="text-slate-700">{r.email}</span> },
    { key: 'phone', header: 'Phone', cell: (r) => <span className="num text-slate-700">{r.phone}</span> },
    {
      key: 'joined',
      header: 'Joined',
      cell: (r) => new Date(r.createdAt).toLocaleDateString('en-PK', { day: 'numeric', month: 'short', year: 'numeric' }),
    },
    { key: 'trips', header: 'Trips', align: 'right', cell: (r) => <span className="num">{r.completedTrips}</span> },
    { key: 'spend', header: 'Spend', align: 'right', cell: (r) => <span className="num font-semibold">{formatPkr(r.totalSpend)}</span> },
  ];

  return (
    <Shell title="Riders" subtitle="Account holders who book rides.">
      <DataTable rows={riders.data ?? []} columns={columns} rowKey={(r) => r.id} loading={riders.isLoading} />
    </Shell>
  );
}
